<template>
  <div id="values">
    <div class="container">
      <div class="title">Nuestros Valores</div>
      <div class="row row-cols-1 row-cols-md-2">
        <div class="col mb-4">
          <div class="card mb-3" style="max-width: 540px;">
            <div class="d-flex justify-content">
              <div class="container_img">
                <img src="@/assets/escuchar.png" class="card-img" alt="escuchar" />
              </div>
              <div class="columna">
                <div class="card-body">
                  <h5 class="card-title">
                    <strong>Saber escuchar</strong>
                  </h5>
                  <p class="card-text">
                    Escuchamos con atención a nuestro cliente para conocer con
                    exactitud sus necesidades. Tomamos muy en cuenta la opinión
                    y las sugerencias de nuestros usuarios. Escuchamos a nuestro
                    equipo, fomentando la comunicación bidireccional.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col mb-4">
          <div class="card mb-3" style="max-width: 540px;">
            <div class="d-flex justify-content">
              <div class="container_img">
                <img src="@/assets/innovar.png" class="card-img" alt="innovar" />
              </div>
              <div class="columna">
                <div class="card-body">
                  <h5 class="card-title">
                    <strong>Siempre innovar</strong>
                  </h5>
                  <p class="card-text">
                    Buscamos activamente las ocasiones para mejorar los
                    productos y servicios. Aprovechamos las sugerencias para dar
                    soluciones novedosas. Actualizamos constantemente nuestros
                    conocimientos y nos reciclamos profesionalmente. Animamos a
                    innovar a nuestro equipo, haciendo realidad ideas
                    compartidas.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col mb-4">
          <div class="card mb-3" style="max-width: 540px;">
            <div class="d-flex justify-content">
              <div class="container_img">
                <img src="@/assets/eficacia.png" class="card-img" alt="eficacia" />
              </div>
              <div class="columna">
                <div class="card-body">
                  <h5 class="card-title">
                    <strong>Actuar con eficacia</strong>
                  </h5>
                  <p class="card-text">
                    Tomamos decisiones ágiles y actuamos con rapidez y
                    dinamismo. Trabajamos bajo un estudio previo de análisis y
                    necesidades reales. Focalizamos la solución a un problema
                    proponiendo alternativas de calidad. Nos adaptamos
                    rápidamente a los cambios y demandas del entorno
                    profesional. Trabajamos en constante comunicación con el
                    usuario.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col mb-4">
          <div class="card mb-3" style="max-width: 540px;">
            <div class="d-flex justify-content">
              <div class="container_img">
                <img src="@/assets/grupo.png" class="card-img" alt="grupo" />
              </div>
              <div class="columna">
                <div class="card-body">
                  <h5 class="card-title">
                    <strong>Trabajar en equipo</strong>
                  </h5>
                  <p class="card-text">
                    Sabemos trabajar en equipo, generando un clima de confianza
                    y respeto mutuo. Actuamos con responsabilidad, disciplina y
                    eficiencia. Cooperamos con los diferentes departamentos de
                    la empresa, asumiendo compromisos encaminados a la
                    consecución de objetivos comunes.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style scoped>
#values {
  background-color: #ebf5ee;
  color: #242325;
}
.title {
  padding-top: 20px;
  margin-bottom: 40px;
  font-size: 36px;
  font-weight: bold;
}
.card-text {
  color: #a3a39e;
  text-align: justify;
  font-size: 16px;
}
.container_img {
  margin-top: 20px;
  margin-left: 20px;
}
img {
  width: 50px;
}
.card-title {
  color: #a3a39e;
  margin-bottom: 32px;
  font-size: 18px;
}
@media screen and (min-width: 768px) and (max-width: 991px) {
  .card {
    height: 500px;
  }
  .card-text {
    font-size: 18px;
  }
}
@media screen and (min-width: 992px) and (max-width: 1199px) {
  .card {
    height: 290px;
  }
}
@media screen and (min-width: 1200px) {
  .card {
    height: 260px;
  }
}
</style>
